"use strict"

import { getLoggedIn, getUserName } from '../utils/cookies';

export default function () {
    if (getLoggedIn()) {
        document.body.classList.add('user-logged-in');

        const userName = getUserName();
        if (userName) {
            document.querySelectorAll('.js-show-username').forEach(el => el.innerText = userName);
        }
    } else {
        document.body.classList.add('user-logged-out');
    }

    document.querySelectorAll('.js-append-returnurl').forEach(el => {
        const separator = el.dataset.href.indexOf('?') === -1 ? '?' : '&';
        el.setAttribute('href', `${el.dataset.href}${separator}returnurl=${encodeURIComponent(document.location.href)}`);
    });
}
